module.exports = __webpack_public_path__ + "static/media/projectManagementIcon.c215b8fe.svg";